import { useEffect } from "react";
import { titleForPath } from "routing/all-routes";
import { useLanguageContext } from "state/languageState/languageContext";
import { nativeNavigationReact } from "./init";
import { syncTabs } from "./NativeRootController";

/**
 * Re-applies the native chrome that carries text when the language changes: each open
 * view's registry title and the tab bar's labels, both written once outside the React
 * tree. iOS only; renders nothing. Web content is handled by LanguageRemountGate.
 *
 * Subscribes to the store rather than using an effect so the registry title lands before
 * React re-renders, leaving NavigationView's layout effect free to override it with a
 * page's own `navigationBarTitle`.
 */
export function NativeLanguageSync() {
  useEffect(
    () =>
      useLanguageContext.subscribe(
        (state) => state.selectedLanguage,
        () => {
          void syncTabs();

          const handle = nativeNavigationReact;
          if (!handle) return;

          for (const view of Object.values(handle.views())) {
            const title = view.data.path ? titleForPath(view.data.path) : undefined;
            if (title) {
              handle.plugin.update({ id: view.id, update: { title } }).catch(() => {});
            }
          }
        },
      ),
    [],
  );

  return null;
}
